const tenthousandMore = (num = 0) => {
  if (num < 10000) {
    return num
  } else if (num === 10000) {
    return '1w'
  }else{
    return '1w+'
  }
}
export default tenthousandMore
